import { render } from "./SignaturePad.vue?vue&type=template&id=96c176a8"
import script from "./SignaturePad.vue?vue&type=script&lang=ts"
export * from "./SignaturePad.vue?vue&type=script&lang=ts"

import "./SignaturePad.vue?vue&type=style&index=0&id=96c176a8&lang=scss"
script.render = render

export default script